import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { Button } from '../../Button/Button.tsx';
import type { AsyncSearchUnionProps, HeaderSelectedListUnionProps } from '../types.ts';

import { SearchBar } from './SearchBar.tsx';

const StyledCardHeader = styled(CardHeader)`
  background: ${({ theme }) => theme.palette.background.paper};
  height: ${({ theme }) => theme.spacing(5)};
`;

const StyledHeaderTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

const StyledCloseButton = styled(Button)`
  font-size: 12px;

  color: ${({ theme }) => theme.palette.error.main};
`;

const StyledHeaderCardContainerGrid = styled(Grid)`
  display: flex;
  justify-content: space-between;
`;

const StyledHeaderWrapperDiv = styled('div')`
  border-radius: 2px 2px 0px 0px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-bottom: none;
`;

export type ListHeaderProps = {
  itemAmount: number;
  searchInput: string;
  setSearchInput: (value: string) => void;
  isDisabled: boolean;
  customPlaceholder?: string;
} & HeaderSelectedListUnionProps &
  AsyncSearchUnionProps;

export const Header = (props: ListHeaderProps) => {
  const { searchInput, setSearchInput, isSelectedList, itemAmount, isDisabled, isAsyncSearch, customPlaceholder } =
    props;
  const { t } = useTranslation();

  const itemText = itemAmount === 1 ? t('item') : t('items');

  const asyncSearchProps: AsyncSearchUnionProps = isAsyncSearch
    ? {
        asyncSearchFn: props.asyncSearchFn,
        isAsyncSearch: true,
      }
    : { isAsyncSearch: false };

  return (
    <StyledHeaderWrapperDiv>
      <SearchBar
        {...asyncSearchProps}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        customPlaceholder={customPlaceholder}
      />
      <Divider />
      <StyledCardHeader
        subheader={
          <StyledHeaderCardContainerGrid data-test="summary-info">
            <StyledHeaderTypography variant="body1" data-test="total-items">
              {`${itemAmount} ${itemText}`}
            </StyledHeaderTypography>
            {isSelectedList && (
              <StyledCloseButton
                variant="text"
                onClick={props.handleRemoveAll}
                data-test="remove-button"
                disabled={!itemAmount || isDisabled}
              >
                {t('REMOVE ALL')}
              </StyledCloseButton>
            )}
          </StyledHeaderCardContainerGrid>
        }
      />
    </StyledHeaderWrapperDiv>
  );
};
